import React from 'react';
import { domToReact } from 'html-react-parser';
import { Link } from 'react-router-dom';

const links = new Map([]);

const getMappedValue = (value) => {
  const trimVal = value
    .replace(process.env.REACT_APP_LOCAL_DOMAIN_NAME, '')
    .replace(/(\/$)/, '');
  return links.has(trimVal) ? links.get(trimVal) : trimVal;
};

const isLinkExternal = ({ href, rel, target }) => {
  if (!href) return false;
  return !!((target && target !== '_self')
    || rel === 'external' || href.match(/^\w+:/) || href.match(/^\/\//) || href.match('#'));
};

const mitigateSecurityIssues = ({
  children,
  attribs: {
    href, rel: initialRel = '',
    target = '', ...restAttribs
  } = {},
}, options) => {
  const securityChecks = [initialRel];
  const mutatedTarget = process.env.REACT_APP_OPEN_ALL_EXTERNAL_LINKS_IN_NEW_TAB ? '_blank' : target;

  if (mutatedTarget === '_blank') {
    [ 'noopener', 'noreferrer' ].forEach((securityMeasure) => {
      if (!initialRel.includes(securityMeasure)) {
        securityChecks.push(securityMeasure);
      }
    });
  }

  const filteredRel = securityChecks.filter(Boolean);
  const relToSet = filteredRel.length ? { rel: filteredRel.join(' ') } : null;
  const targetToSet = mutatedTarget ? { target: mutatedTarget } : null;

  return (<a href={href} {...relToSet} {...targetToSet} {...restAttribs}>{domToReact(children, options)}</a>);
};

const aTagRenderer = (node) => {
  const { attribs, children, options } = node;
  let href;
  try {
    href = getMappedValue(attribs.href);
  } catch (e) {
    href = '';
  }
  return (!isLinkExternal({ ...attribs, href })
    ? (
      <Link to={{ pathname: (href) }}>
        {domToReact(children, options)}
      </Link>
    ) : mitigateSecurityIssues(node, options)
  );
};

export default aTagRenderer;
